var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountOperationFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#00205A",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.102 18.39L28.162 17.33C28.942 16.55 28.942 15.28 28.162 14.5L26.752 13.09C25.972 12.31 24.702 12.31 23.922 13.09L22.862 14.15L27.102 18.39ZM21.442 15.56L12.392 24.61C12.302 24.7 12.252 24.83 12.252 24.96V28.5C12.252 28.78 12.472 29 12.752 29H16.292C16.422 29 16.552 28.95 16.642 28.85L25.692 19.8L21.442 15.56ZM27.252 25.5C27.252 27.69 24.712 29 22.252 29C21.702 29 21.252 28.55 21.252 28C21.252 27.45 21.702 27 22.252 27C23.792 27 25.252 26.27 25.252 25.5C25.252 25.03 24.772 24.63 24.022 24.3L25.502 22.82C26.572 23.45 27.252 24.29 27.252 25.5ZM12.832 21.35C11.862 20.79 11.252 20.06 11.252 19C11.252 17.2 13.142 16.37 14.812 15.64C15.842 15.18 17.252 14.56 17.252 14C17.252 13.59 16.472 13 15.252 13C13.992 13 13.452 13.61 13.422 13.64C13.072 14.05 12.442 14.1 12.022 13.76C11.612 13.42 11.532 12.81 11.872 12.38C11.982 12.24 13.012 11 15.252 11C17.492 11 19.252 12.32 19.252 14C19.252 15.87 17.322 16.72 15.612 17.47C14.672 17.88 13.252 18.5 13.252 19C13.252 19.31 13.682 19.6 14.322 19.86L12.832 21.35Z",
    fill: "#00205A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountOperationFilledIcon);
export default __webpack_public_path__ + "static/media/account_operation_filled_icon.4979bd9362c454ec6d0ed329b76c1b14.svg";
export { ForwardRef as ReactComponent };